(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-collections"] && !Shopify.designMode) return;
  try {
    
  class CategoryGridList extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const link = event.target.closest('.category-grid__link');
        if (!link) return;

        const trackName = link.dataset.trackName;

        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'category_grid_click',
            element_clicked: trackName,
          });

          if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
            window.Shopify.analytics.publish('custom_event', {
              name: 'category_grid_interaction',
              payload: { clicked_category: trackName },
            });
          }
        } catch (error) {
          // Never let analytics errors block navigation.
        }
      });
    }
  }

  if (!customElements.get('category-grid-list')) {
    customElements.define('category-grid-list', CategoryGridList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
